import { prefix } from '@root/utils/Lang';

const modulePrefix = 'module.promotionCategory';

const translations = {
    'promotionCategory': 'Promóciós kategóriák',
    'create.title': 'Promóciós kategória hozzáadása',
    'promotionCategoryCreate': 'Új promóciós kategória',
    'edit.title': 'Promóciós kategória szerkesztése',

    'id.title': 'ID',
    'name.title': 'Név',
    'url_key.title': 'URL',
    'url_key.hint': 'Ne használj ékezetes betűket, szóközt és különleges karaktereket!',
    'url_key.urlhint': 'URL a siteon',
    'content.title': 'Tartalom',
    'sort.title': 'Sorrend',
    'date_from.title': 'Megjelenik -tól',
    'date_to.title': 'Megjelenik -ig',
    'keywords.title': 'Meta keywords',
    'keywords.hint': 'A kulcsszavak között használj vesszőt és szóközt!',
    'description.title': 'Meta description',
    'description.hint': 'Maximum 300 karaktert írj!',
    'is_enable.title': 'Engedélyezve',
    'promotion_place.title': 'Megjelenés helye',
    'promotion_place.hint': 'Főoldalon melyik blokkban jelenjen meg?',
    'products.title': 'Termék ID-k',

    'tabs.default': 'Alapadatok',
    'tabs.products': 'Termékek',

    'deleteAll.title': 'Összes termék törlése',
    'deleteAllDialog.body': 'Biztosan törlöd az összes kapcsolt terméket?',
};

export default prefix(modulePrefix, translations);



// WEBPACK FOOTER //
// ./src/modules/PromotionCategory/lang/hu.ts